module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<th>\n  <a class="remove-choice" href="#">\n    <img src="/static/images/icon-trash.gif" />\n  </a>\n  <input type="text" class="choice-name" value="'+
((__t=( name ))==null?'':_.escape(__t))+
'" maxlength="30" /><br/>\n  <select name="weeks.'+
((__t=( week_key ))==null?'':_.escape(__t))+
'.rows.'+
((__t=( key ))==null?'':_.escape(__t))+
'.colour" class="choice-colour">\n    <option value="red"';
 if(colour=="red"){ print(" selected") } 
__p+='>Red</option>\n    <option value="green"';
 if(colour=="green"){ print(" selected") } 
__p+='>Green</option>\n    <option value="blue"';
 if(colour=="blue"){ print(" selected") } 
__p+='>Blue</option>\n    <option value="orange"';
 if(colour=="orange"){ print(" selected") } 
__p+='>Orange</option>\n    <option value="purple"';
 if(colour=="purple"){ print(" selected") } 
__p+='>Purple</option>\n    <option value="yellow"';
 if(colour=="yellow"){ print(" selected") } 
__p+='>Yellow</option>\n  </select>\n</th>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./menupicker/templates/choice.html
// module id = 267
// module chunks = 0